import { FC, useEffect, useState } from "react";
import { selectIsAuthenticated } from "@onmo/auth";
import { UserSubscriptionStatus } from "@onmo/graphql/graphql";
import { useAppSelector } from "../../hooks";
import { useGamepadContext } from "../../../contexts/GamepadProvider";
import { PaymentFailedPopup } from "./PaymentFailedPopup";
import { useAAASubscription } from "../../../hooks/useAAASubscription";

const DISMISSED_KEY = "payment_failed_dismissed_renewal";

export const PaymentFailedGuard: FC = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { setActiveElement } = useGamepadContext();
  const { data } = useAAASubscription({
    skip: !isAuthenticated,
  });

  const renewalDate = data?.me?.subscription?.renewalDate;
  const isGracePeriod =
    data?.me?.subscription?.status === UserSubscriptionStatus.Grace;

  const [dismissed, setDismissed] = useState(
    () =>
      !!renewalDate && sessionStorage.getItem(DISMISSED_KEY) === renewalDate,
  );

  useEffect(() => {
    if (!isGracePeriod || !renewalDate) return;
    setDismissed(sessionStorage.getItem(DISMISSED_KEY) === renewalDate);
  }, [isGracePeriod, renewalDate]);

  const shouldOpen = !!isGracePeriod && !dismissed;
  useEffect(() => {
    if (!shouldOpen) return;
    const id = requestAnimationFrame(() => {
      const btn = document.querySelector(
        'dialog [data-gamepad="default-selected"]',
      ) as HTMLElement | null;
      if (btn) setActiveElement(btn);
    });
    return () => cancelAnimationFrame(id);
  }, [shouldOpen, setActiveElement]);

  const onClose = () => {
    if (renewalDate) sessionStorage.setItem(DISMISSED_KEY, renewalDate);
    setDismissed(true);
  };

  return <PaymentFailedPopup open={shouldOpen} onClose={onClose} />;
};
